export default "__VITE_ASSET__BJklzTMH__"